


<!-- Copyright (c) 2019-2023 Cigent Technology Inc. All Rights Reserved. -->

<div class="container">

    <div class="buttons-container">
        <button mat-raised-button color="primary" (click)="openDownloadDialog()"><span class="mdi mdi-download" aria-hidden="true"></span> {{'key-management.export-keys-button' | translate}}</button>
        <button mat-raised-button color="primary" (click)="openUploadDialog()"><span class="mdi mdi-upload" aria-hidden="true"></span> {{'key-management.import-key-button' | translate}}</button>
    </div>

    <div class="table-wrapper">
        <div class="table-header">
            <strong>{{dataSource.length}} {{'ENCRYPTION_KEYS' | translate}}</strong>
        </div>
        <table mat-table *ngIf="!!dataSource" [dataSource]="dataSource" aria-describedby="List of encryption keys">

            <ng-container matColumnDef="name">
                <th scope="col" mat-header-cell *matHeaderCellDef>{{'cryptography.manage-keys.table.name' | translate}}</th>
                <td mat-cell *matCellDef="let key">{{key.name}}</td>
            </ng-container>

            <ng-container matColumnDef="uuid">
                <th scope="col" mat-header-cell *matHeaderCellDef>{{'cryptography.manage-keys.table.uuid' | translate}}</th>
                <td mat-cell *matCellDef="let key">{{key.uuid}}</td>
            </ng-container>

            <ng-container matColumnDef="type">
                <th scope="col" mat-header-cell *matHeaderCellDef>{{'cryptography.manage-keys.table.type' | translate}}</th>
                <td mat-cell *matCellDef="let key">{{key | keyStatusText}}</td>
            </ng-container>

            <ng-container matColumnDef="expirationDate">
                <th scope="col" mat-header-cell *matHeaderCellDef>{{'cryptography.manage-keys.table.expiration-date' | translate}}</th>
                <td mat-cell *matCellDef="let key">{{key.expirationDate | date : 'mediumDate'}}</td>
            </ng-container>

            <ng-container matColumnDef="actions">
                <th scope="col" mat-header-cell *matHeaderCellDef>{{'L_ACTIONS' | translate}}</th>
                <td mat-cell *matCellDef="let key">
                    <button mat-mini-fab (click)="openExportDialog(key)" matTooltip="{{'cryptography.manage-keys.export-to-standard' | translate}}"><span class="mdi mdi-download" aria-hidden="true"></span></button>
                    <button mat-mini-fab (click)="openEditKeyDialog(key)" matTooltip="{{'cryptography.manage-keys.edit-key' | translate}}"><span class="mdi mdi-pencil" aria-hidden="true"></span></button>
                </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="columns; sticky: true"></tr>
            <tr mat-row *matRowDef="let event; columns: columns"></tr>

        </table>
    </div>

</div>